import React from 'react';
import { CardSmallStats } from '@/components/CardSmallStats/CardSmallStats';
import SectionSubtitle from '@/components/Typography/SectionSubtitle';

interface ServiceRecord {
  date: string;
  mileage: number;
  type: string;
  description: string;
  cost: number;
  workshop: string;
  status: 'completed' | 'pending' | 'cancelled';
}

interface UpcomingService {
  type: string;
  estimatedDate: string;
  estimatedMileage: number;
  description: string;
}

interface RecallInfo {
  date: string;
  description: string;
  status: 'completed' | 'pending';
  recallNumber: string;
}

export interface RaportHSPServiceData {
  totalRecords: number;
  lastServiceDate: string;
  majorServices: ServiceRecord[];
  upcomingServices: UpcomingService[];
  recalls: RecallInfo[];
}

export interface RaportHSPServiceProps {
  serviceData: RaportHSPServiceData;
}

export const RaportHSPService: React.FC<RaportHSPServiceProps> = () => {
  return (
    <div className="mt-10 space-y-8">
      <SectionSubtitle title="Podsumowanie szkód" />
      {/* Statystyki serwisowe */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        <CardSmallStats
          icon="car-accident"
          title="Ilość odnotowanych szkód"
          subtitle={`ilość szkód: ${1}`}
          variant="warning"
        />

        <CardSmallStats
          icon="ruler-measure"
          title="Łączna wartość"
          subtitle={`28.000 PLN`}
        />

        <CardSmallStats
          icon="car-crash"
          title="Szkody całkowite"
          subtitle={`ilość szkód: ${0}`}
        />

        <CardSmallStats
          icon="location-pin"
          title="Kraje występowania szkód"
          subtitle={`Niemcy, Polska`}
        />
      </div>
    </div>
  );
};
